<template>
  <div>
    Oi oi! It ain't here, that what ya looking for! You may try again, go ahead... Try again!
  </div>
</template>
<script>
export default {};
</script>
